import type { InstallmentCalculatorConfig } from './installmentCalculator.types';

export const installmentCalculatorConfig: InstallmentCalculatorConfig = {
  hasLegalHints: false,
  hasLegalHintsImage: false,
  hasInfoCallToAction: true,
  InstallmentCalculatorCallToActionLayout: { layout: 'Layout1' },
  hasSpecialCreditColors: false,
};
